import { FC } from "react";
import styled from "styled-components";

const Container = styled.div`
    position: relative;
    display: grid;
    grid-gap: 20px;
    grid-auto-flow: column;
    @media (max-width: 1240px) {
        grid-auto-flow: row;
    }
`;

const ProductCardList: FC<{ children: React.ReactNode }> = ({ children }) => {
    return <Container>{children}</Container>;
};

export default ProductCardList;
